import { render, staticRenderFns } from "./Billings.vue?vue&type=template&id=4f7d4941&scoped=true"
import script from "./Billings.vue?vue&type=script&lang=js"
export * from "./Billings.vue?vue&type=script&lang=js"
import style0 from "./Billings.vue?vue&type=style&index=0&id=4f7d4941&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7d4941",
  null
  
)

export default component.exports